import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import '../styles/tonPaymentStatusModal.css';
import ModalBackground from '../shared/components/ModalBackground';
import { useTranslation } from 'react-i18next';

const TonPaymentStatusModal = ({
  status = 'processing',
  item,
  tonAmount,
  error,
  onClose,
  onRetry,
}) => {
  const { t } = useTranslation();
  const isProcessing = status === 'processing';
  const isFailed = status === 'failed';

  useEffect(() => {
    if (status === 'success') {
      onClose?.();
    }
  }, [status, onClose]);

  if (status === 'success' || status === 'idle') {
    return null;
  }

  const title = isFailed ? t('payment.status.failed_title', 'Payment Failed!') : t('payment.status.processing_title', 'Processing Payment!');
  const subtitle = isFailed
    ? t('payment.status.failed_text', 'The DATUM system couldn’t verify your transaction. Please check your connection or try again later.')
    : t('payment.status.processing_text', 'Syncing your transaction with the DATUM system. Please stand by while we verify the payment data.');

  const footerText = isFailed ? t('payment.status.aborted', 'Transaction aborted!') : t('payment.status.wait', 'Please wait!');
  // eslint-disable-next-line no-unused-vars
  const primaryActionLabel = isFailed ? t('payment.status.try_again', 'Try Again') : t('payment.status.confirming', 'Confirming Your Purchase');

  const handlePrimaryAction = () => {
    if (isFailed) {
      onRetry?.();
    }
  };

  // tonAmount arrives as a bare number string (see PurchaseActions) — add the currency once here
  const displayTonAmount = tonAmount ? `${tonAmount} GRAM` : '';
  const imageSrc = item?.img || './Coins_0.png';

  return (
    <div className="ton-payment-modal-overlay">
      <div className={`ton-payment-card ${isFailed ? 'failed' : 'processing'}`}>
        <div className="ton-payment-sheet" onClick={(event) => event.stopPropagation()}>
          <button className="ton-payment-close" type="button" onClick={onClose}>
            <img src="/close.png" alt={t('common.close', 'Close')} />
          </button>

          <div className="ton-payment-header" style={{ position: 'relative', overflow: 'visible' }}>
            <ModalBackground />
            <h2 style={{ position: 'relative', zIndex: 1 }}>{title}</h2>
            <img className="purchase-modal-close" src="/close.png" alt={t('common.close', 'Close')} onClick={() => {onClose?.()}} style={{ position: 'absolute', zIndex: 1 }} />

          </div>

          <div className="ton-payment-content">
            <img
              src={imageSrc}
              alt={item?.label || t('payment.status.gram_item', 'GRAM item')}
              className="ton-payment-image"
            />
            <div className="ton-payment-quantity">{item?.label}</div>
            <div className="ton-payment-price">{displayTonAmount}</div>

            <p className="ton-payment-description">{subtitle}</p>

            {isProcessing && (
              <div className="ton-payment-dots">
                <span className="dot dot-1" />
                <span className="dot dot-2" />
                <span className="dot dot-3" />
              </div>
            )}

            {isFailed && error && (
              <p className="ton-payment-error">{error}</p>
            )}

            <div className="ton-payment-footer-text">{footerText}</div>

          </div>
        </div>
      </div>
    </div>
  );
};

TonPaymentStatusModal.propTypes = {
  status: PropTypes.oneOf(['idle', 'processing', 'failed', 'success']),
  item: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    img: PropTypes.string,
  }),
  tonAmount: PropTypes.string,
  error: PropTypes.string,
  onClose: PropTypes.func,
  onRetry: PropTypes.func,
};

export default TonPaymentStatusModal;


